<template>
  <div class="rounded-lg border border-emerald-200 bg-emerald-50 p-6">
    <h4 class="text-lg font-semibold text-emerald-900 mb-2">Livraison gratuite</h4>
    <p class="text-emerald-800 text-sm">
      Les frais de livraison sont offerts par votre boutique. Aucune étiquette eFashion n'est nécessaire.
    </p>
    <div v-if="trackingLabels.length" class="mt-4 space-y-3">
      <p class="text-sm font-medium text-black">Suivi communiqué au client</p>
      <div
        v-for="label in trackingLabels"
        :key="label.id_commande_etiquette"
        class="rounded-md border border-emerald-200 bg-white p-3 text-sm"
      >
        <p class="text-gray-700">{{ carrierLabel(label.id_livraison) }}</p>
        <a
          v-if="trackingUrl(label)"
          :href="trackingUrl(label)!"
          target="_blank"
          rel="noopener noreferrer"
          class="mt-1 inline-block font-semibold text-blue-600 underline"
        >
          {{ label.tracking_number }}
        </a>
        <strong v-else class="mt-1 block text-black">{{ label.tracking_number }}</strong>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { getOrderLabels } from "@/api/orders";
import type { LabelPropsBase, OrderLabel } from "@/types";
import { getTrackingUrl } from "@/utils/trackingUrl";
import { FREE_SHIPPING_CARRIERS } from "@/utils/freeShippingTracking";

const props = defineProps<LabelPropsBase>();
const trackingLabels = ref<OrderLabel[]>([]);

const carrierLabel = (carrierId?: number | null) =>
  FREE_SHIPPING_CARRIERS.find((carrier) => carrier.id === Number(carrierId))
    ?.label || "Transporteur renseigné";

const trackingUrl = (label: OrderLabel) =>
  getTrackingUrl(label.tracking_number, label.id_livraison);

onMounted(async () => {
  try {
    const labels = await getOrderLabels(props.orderId);
    trackingLabels.value = labels.filter((label) => label.tracking_number);
  } catch {
    trackingLabels.value = [];
  }
});
</script>
